import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicFileReferrerBig({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M49.5 4v48a3.5 3.5 0 01-3.5 3.5H10A3.5 3.5 0 016.5 52V14.2L20.2.5H46A3.5 3.5 0 0149.5 4z"
        fill="#fff"
        stroke="#E3E8E8"
      />
      <path d="M20 0v10a4 4 0 01-4 4H6L20 0z" fill="#E3E8E8" />
      <rect x={28} y={39} width={27} height={13} rx={2} fill="#3EA769" />
      <path
        d="M34.2 45.63l-2.07-3.06h1.63l1.26 2.06 1.3-2.06h1.56l-2.06 3.07L38.06 49h-1.69l-1.4-2.22L33.54 49h-1.59l2.25-3.37zm4.87-3.06h1.42v5.24h3.13V49h-4.55v-6.43zm6.75 4.3a1.09 1.09 0 00.42.92c.14.09.29.15.46.2a2.3 2.3 0 001.35-.09.9.9 0 00.32-.24c.08-.1.12-.24.12-.4a.56.56 0 00-.17-.43c-.1-.1-.25-.2-.43-.27a4.36 4.36 0 00-.61-.19 16.9 16.9 0 01-1.4-.4c-.22-.08-.43-.2-.6-.34-.19-.13-.33-.3-.45-.5-.1-.22-.16-.47-.16-.77a1.69 1.69 0 01.76-1.46c.23-.16.5-.28.78-.36a3.88 3.88 0 011.83 0c.3.07.58.19.82.36a1.91 1.91 0 01.78 1.6h-1.36a1.1 1.1 0 00-.13-.49.76.76 0 00-.27-.3 1.16 1.16 0 00-.4-.15 2.34 2.34 0 00-.81 0 .8.8 0 00-.54.35.6.6 0 00-.1.34c0 .12.03.23.08.3.05.08.14.15.28.22s.34.13.58.2a137.61 137.61 0 001.48.38 2.07 2.07 0 011.18.86c.15.23.23.52.23.88a1.8 1.8 0 01-.68 1.48c-.22.18-.5.32-.84.42-.33.1-.71.15-1.15.15-.35 0-.7-.04-1.04-.13a2.58 2.58 0 01-.88-.4 2.04 2.04 0 01-.82-1.74h1.37z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.43 25a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm7.45 13a6.62 6.62 0 100-13.24 6.62 6.62 0 000 13.24zM22.2 26.23l3.56 3.56a8.32 8.32 0 00.54 4.93h-7.67a2.13 2.13 0 01-2.13-2.13v-.43c0-3.2 2.53-5.8 5.7-5.93zm15.06 5.61l-.03.05-.05.05-2.14 2.22a.8.8 0 01-1.22-1.02l.08-.09.83-.86H31.2a.8.8 0 01-.11-1.58l.1-.01h3.54l-.83-.86a.8.8 0 011.05-1.19l.1.08 2.13 2.21.06.07.03.05.03.06.03.04.03.1.03.12a.8.8 0 01-.07.46l-.06.1z"
        fill="#999"
      />
    </svg>
  );
}

SvgPicFileReferrerBig.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicFileReferrerBig.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicFileReferrerBig svgRef={ref} {...props} />
));
export default ForwardRef;
